import { useState, useEffect } from "react";
import BarChart, {
  ActivitiesChart,
  PhysicalExecutionChart,
  TEFChart,
} from "../graphs/graph_components/BarChart";
import { Button, Carousel, Table } from "antd";
import { ArrowLeftCircleIcon, ArrowRightCircleIcon } from "@heroicons/react/24/solid";
import { useNavigate, useOutletContext } from "react-router-dom";
import { getFromApiFunction } from "../../services/api/apiFunctions";
import "./home.scss";

function CustomNextArrow(props: any) {
  const { className, style, onClick } = props;
  return <ArrowRightCircleIcon className={className} style={style} onClick={onClick} />;
}

function CustomPrevArrow(props: any) {
  const { className, style, onClick } = props;
  return <ArrowLeftCircleIcon className={className} style={style} onClick={onClick} />;
}

const settings = {
  nextArrow: <CustomNextArrow />,
  prevArrow: <CustomPrevArrow />,
};

function SummaryTable() {
  const columns = [
    {
      key: "label",
      dataIndex: "label",
    },
    {
      key: "value",
      dataIndex: "value",
    },
  ];

  const data = [
    {
      key: 1,
      label: "Agence d’exécution",
      value: "Société Béninoise d’Energie Electrique (SBEE)",
    },
    {
      key: 2,
      label: "Zone du projet",
      value: "Bénin-12 Départements",
    },
    {
      key: 4,
      label: "Montant du Prêt",
      value: "200.000.000 USD ; soit 108 milliards",
    },
    {
      key: 5,
      label: "Montant du Budget National",
      value: "900.000.000 FCFA",
    },
    {
      key: 8,
      label: "Date de démarrage effectif",
      value: "23/11/2021",
    },
  ];

  return (
    <Table
      dataSource={data}
      columns={columns}
      className="hide-header-table"
      rowClassName={(_, index) => "row " + (index % 2 === 0 ? "even-row" : "odd-row")}
      pagination={false}
    />
  );
}

export default function Home() {
  const [intervention, setFiliere, publicIsAnalyzeOpenSetter] = useOutletContext<any>();
  const navigate = useNavigate();

  const [indicators, setIndicators] = useState([]);

  const moveToMapping = (filiereConst: any) => {
    setFiliere(filiereConst);
    navigate("/mapping");
  };

  useEffect(() => {
    getFromApiFunction("/indicators/?show_on_home=1").then((response) => {
      setIndicators(response.data.results);
    });
  }, []);
  return (
    <div className="home-background h-screen">
      <div className="max-w-[1400px] mx-auto my-0 h-full">
        <div className="pt-2 flex justify-center gap-2 items-center sm:flex-row flex-col">
          <span
            className="w-[200px] lg:w-auto !h-[67px] lg:!h-[100px] bg-white"
            style={{ overflow: "hidden" }}
          >
            <img
              className="h-[67px] lg:h-[100px] m-auto"
              src="./assets/logo-p2ae.png"
            />
          </span>
          <span className="max-w-[200px] w-[200px] !h-[67px] lg:!h-[100px] lg:w-auto bg-white wb-logo">
            <img src="./assets/world-bank.png" />
          </span>
        </div>
        <div className="flex pt-12 custom-header">
          <h2 className="w-ful mx-auto my-0 text-center font-light text-xl font-normal tracking-[2px] sm:tracking-[5px] text-slate-400 !text-lg sm:!leading-10 sm:!text-[2rem] md:!leading-[2.75rem] md:!text-[2.5rem] custom-title">
            PLATEFORME DE SUIVI DES INTERVENTIONS <br /> ET DES BENEFICIAIRES DU
            <span className="font-semibold uppercase">
              {" "}
              Projet d'Augmentation de l'Accès à l'électricité{" "}
            </span>
            (<span className="text-[#3f48cc]">P2AE</span>)
          </h2>
        </div>
        <div className="flex justify-center gap-4 mt-12 w-[1000px] mx-auto">
          <Button
            // type="primary"
            className="block m-auto text-xl font-bold home-button text-white"
            onClick={() => navigate("mapping")}
          >
            MAPPING
          </Button>
          <Button
            // type="primary"
            className="block m-auto text-xl font-bold home-button text-white"
            onClick={() => publicIsAnalyzeOpenSetter(true)}
          >
            TABLEAU DE BORD
          </Button>
        </div>
        <div className="mt-12 bg-white rounded-t-lg block m-auto h-[500px] w-[1000px]">
          <div className="">
            <Carousel
              arrows
              dots={false}
              infinite={true}
              {...settings}
              autoplay={false}
            >
              <div className="sm:space-y-12 mx-auto my-0 h-full mt-[100px]">
                <div className="flex items-center justify-center space-x-9 p-2 lg:p-0">
                  <div className="flex flex-col lg:flex-row items-center gap-4 lg:gap-0 lg:space-x-10">
                    <span className="w-[800px] hidden sm:block">
                      <SummaryTable />
                    </span>
                  </div>
                </div>
              </div>
              <div className="sm:space-y-12 mx-auto my-0 h-full">
                <div className="flex items-center justify-center space-x-9 p-2 lg:p-0">
                  <div className="flex flex-col lg:flex-row items-center gap-4 lg:gap-0 lg:space-x-10">
                    <span className="w-[500px] hidden sm:block mt-[-50px]">
                      <PhysicalExecutionChart />
                    </span>
                  </div>
                </div>
              </div>
              <div className="sm:space-y-12 mx-auto my-0 h-full">
                <div className="flex items-center justify-center space-x-9 p-2 lg:p-0">
                  <div className="flex flex-col lg:flex-row items-center gap-4 lg:gap-0 lg:space-x-10">
                    <span className="w-[700px] hidden sm:block mt-[50px]">
                      <TEFChart />
                    </span>
                  </div>
                </div>
              </div>
              <div className="sm:space-y-12 mx-auto my-0 h-full">
                <div className="flex items-center justify-center space-x-9 p-2 lg:p-0">
                  <div className="flex flex-col lg:flex-row items-center gap-4 lg:gap-0 lg:space-x-10">
                    <span className="w-[500px] hidden sm:block">
                      <ActivitiesChart />
                    </span>
                  </div>
                </div>
              </div>
            </Carousel>
          </div>
        </div>
      </div>
    </div>
  );
}
